<template>
<div>
  <v-toolbar  color="primary">
     <v-toolbar-side-icon  class="white--text" ></v-toolbar-side-icon>
    <v-toolbar-title class="white--text" >Ommini Pré-Pago</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat>Link One</v-btn>
      <v-btn flat>Link Two</v-btn>
      <v-btn flat>Link Three</v-btn>
    </v-toolbar-items>
  </v-toolbar>         
  
  <v-container grid-list-md text-xs-center>
      
    <v-layout row wrap>

       <v-flex xs12 >
        <v-card light class="white--text" color="brown">
        
              <v-card-title primary-title>
                <div class=" .pa-1 text-md-left headline">Ola, Steve jobs</div>
                
              </v-card-title>
              <v-card-title primary-title>
                <div><h1 class="display-4 text-md-center"> R$ 500,00</h1></div>
              </v-card-title>
              <div><h1 class="display-1"> Seu saldo</h1></div>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
        
        </v-card>
      </v-flex>
      
        <v-flex xs12>
            <v-card class="light-blue lighten-3"  color="primary">
            <v-card-text class="px-0">EXTRATO</v-card-text>
            </v-card>
        </v-flex>

        <v-flex xs12>
            <v-card color="secondary">
            <v-card-text class="px-0">Lojas</v-card-text>
            </v-card>
        </v-flex>
         
       <!-- <v-flex xs6 >
        <v-card white color="">
          <v-card-text class="px-0">
              <template>
    <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
    >
                <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                    <span slot="activator">
                    {{ props.header.text }}
                    </span>
                    <span>
                    {{ props.header.text }}
                    </span>
                </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">{{ props.item.calories }}</td>
                <td class="text-xs-right">{{ props.item.fat }}</td>
                <td class="text-xs-right">{{ props.item.carbs }}</td>
                <td class="text-xs-right">{{ props.item.protein }}</td>
                <td class="text-xs-right">{{ props.item.iron }}</td>
                </template>
            </v-data-table>
            </template>

            </v-card-text>
            </v-card>
        </v-flex>-->
    </v-layout>
    </v-container>
    </div>
    </template>

<script>
export default {
    data: () => ({
      idFranquia:localStorage.getItem('tituloApp'),  
      cards: [
        { title: 'Pre-fab homes', src: '/static/doc-images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: '/static/doc-images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: '/static/doc-images/cards/plane.jpg', flex: 6 }
      ],

      headers: [
          {
            text: 'Dessert (100g serving)',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Calories', value: 'calories' },
          { text: 'Fat (g)', value: 'fat' },
          { text: 'Carbs (g)', value: 'carbs' },
          { text: 'Protein (g)', value: 'protein' },
          { text: 'Iron (%)', value: 'iron' }
        ],
        items: [
          {
            value: false,
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%'
          },
          {
            value: false,
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%'
          },
          {
            value: false,
            name: 'Eclair',
            calories: 262,
            fat: 16.0,
            carbs: 23,
            protein: 6.0,
            iron: '7%'
          },
          {
            value: false,
            name: 'Cupcake',
            calories: 305,
            fat: 3.7,
            carbs: 67,
            protein: 4.3,
            iron: '8%'
          },
          {
            value: false,
            name: 'Gingerbread',
            calories: 356,
            fat: 16.0,
            carbs: 49,
            protein: 3.9,
            iron: '16%'
          },
          {
            value: false,
            name: 'Jelly bean',
            calories: 375,
            fat: 0.0,
            carbs: 94,
            protein: 0.0,
            iron: '0%'
          },
          {
            value: false,
            name: 'Lollipop',
            calories: 392,
            fat: 0.2,
            carbs: 98,
            protein: 0,
            iron: '2%'
          },
          {
            value: false,
            name: 'Honeycomb',
            calories: 408,
            fat: 3.2,
            carbs: 87,
            protein: 6.5,
            iron: '45%'
          },
          {
            value: false,
            name: 'Donut',
            calories: 452,
            fat: 25.0,
            carbs: 51,
            protein: 4.9,
            iron: '22%'
          },
          {
            value: false,
            name: 'KitKat',
            calories: 518,
            fat: 26.0,
            carbs: 65,
            protein: 7,
            iron: '6%'
          }
        ]
    })
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue